
import React from 'react';
import { Button } from '../ui/button';
import { LucideIcon } from 'lucide-react';

interface TimetableButtonProps {
  icon: LucideIcon;
  children: React.ReactNode;
  onClick: () => void;
  variant?: 'default' | 'outline';
  notification?: boolean;
  disabled?: boolean;
}

const TimetableButton = ({ 
  icon: Icon, 
  children, 
  onClick, 
  variant = 'outline',
  notification = false,
  disabled = false
}: TimetableButtonProps) => {
  // Add debounce handler to prevent multiple clicks
  const handleClick = (e: React.MouseEvent) => {
    if (disabled) return;
    
    // Add a click prevention mechanism
    const button = e.currentTarget as HTMLButtonElement;
    if (button) {
      // Temporarily disable the button to prevent double-clicks
      button.disabled = true;
      
      // Call the onClick handler
      onClick();
      
      // Re-enable after a short delay
      setTimeout(() => {
        if (button) {
          button.disabled = false;
        }
      }, 500);
    }
  };
  
  return (
    <Button
      variant={variant}
      size="sm"
      className="flex items-center h-8 px-3 text-xs sm:text-sm sm:h-9 sm:px-4 relative"
      onClick={handleClick}
      disabled={disabled}
    >
      <Icon className="mr-1.5 h-3.5 w-3.5 sm:h-4 sm:w-4" />
      {children}
      {notification && (
        <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 rounded-full" />
      )}
    </Button>
  );
};

export default TimetableButton;
